var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"login-home"}},[_c('div',{staticClass:"login"},[_c('div',{attrs:{"id":"okta-signin-container"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }